import { Box, Button as MuiButton } from '@mui/material';
import React from 'react';

import { v4AccentButtonSx, v4GhostButtonSx } from '../../atoms/Button';

interface EditFormShellProps {
  /** Whether anything precedes this form — a saved row, or an earlier form. */
  showDivider: boolean;
  canEdit: boolean;
  onCancel: () => void;
  onSave: () => void;
  children: React.ReactNode;
}

/**
 * The inline editor for one address or contact.
 *
 * Tinted and inset so it reads as a surface being worked on rather than another
 * saved row, and its actions carry the same two weights as the sticky header:
 * filled teal commits, hairline steps back.
 */
export const EditFormShell: React.FC<EditFormShellProps> = ({
  showDivider,
  canEdit,
  onCancel,
  onSave,
  children,
}) => (
  <Box
    sx={{
      mt: showDivider ? 1.5 : 0,
      p: 1.5,
      borderRadius: '6px',
      border: 1,
      borderColor: 'v4.border',
      bgcolor: 'v4.tableEven',
    }}
  >
    {children}
    {canEdit && (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5 }}>
        <MuiButton variant="outlined" size="small" onClick={onCancel} sx={v4GhostButtonSx}>
          Cancel
        </MuiButton>
        <MuiButton variant="contained" size="small" onClick={onSave} sx={v4AccentButtonSx}>
          Save
        </MuiButton>
      </Box>
    )}
  </Box>
);
